

















import Vue from 'vue';

export default Vue.extend({
  props: {
    width: {
      type: Number,
      default: 93,
    },
    height: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
  },
});
